import { Grid } from '@material-ui/core';
import { Autocomplete,  Box,  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, LinearProgress, TextField } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import LocalisationMisService from '../../../services/LocalisationMisService';
import MissionTransportService from '../../../services/MissionTransportService';
import TimeSheetMissionService from '../../../services/TimeSheetMissionService';
// import MadagascarMap from '../../../components/MadagascarMap';
import useStyles from '../../../styles/MissionAssignVehicle.style';

const bullRed = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '5px', transform: 'scale(0.8)', color: 'red', fontSize: '20px' }}
  >
    *
  </Box>
)

const DestinationAddDialog = (props) => {
    const classes = useStyles();
    const { destDialog, setDestDialog, setMessage, fetchDestinations, onAddDestination } = props;
    const { open, agenda_id, mission_timesheet_id, onClose, missionnaries } = destDialog;
    const initFormValues = useMemo(() => ({
        action: 'add',
        type : '',
        date_begin : '',
        date_end : '',
        heure_begin : '',
        heure_end : '',
        region_depart : '',
        district_depart : '',
        commune_depart : '',
        region_arrivee : '',
        district_arrivee : '',
        commune_arrivee : '',
        lieu_depart : '',
        lieu_arrivee : '',
        observation : '',
        mission_planning_agenda_id : agenda_id,
        mission_timesheet_id : mission_timesheet_id,
        missionnaries : [],
    }), [agenda_id, mission_timesheet_id]);
    const [formvalues, setFormvalues] = useState(initFormValues);
    const [regions, setRegions] = useState([]);
    const [districtsDepart, setDistrictsDepart] = useState([]);
    const [districtsArrivee, setDistrictsArrivee] = useState([]);
    const [communesDepart, setCommunesDepart] = useState([]);
    const [communesArrivee, setCommunesArrivee] = useState([]);
    // const [geodata, setGeodata] = useState({});
    const [loading, setLoading] = useState({
        region_arrivee: false,
        region_depart: false,
        district_arrivee: false,
        district_depart: false,
        commune_arrivee: false,
        commune_depart: false,
        submit: false,
    });
    const [transport, setTransport] = useState([]);

   useEffect(() => {
       const fetchRegions = async () => {
        try {
            setLoading((prev) => ({ ...prev, region_depart: true, region_arrivee: true }));
            const regionsResult = await LocalisationMisService.getRegions();
            if(regionsResult.status){
                setRegions(regionsResult.data);
                setLoading((prev) => ({ ...prev, region_depart: false, region_arrivee: false }) );
            }
        } catch (error) {
            console.error("Error fetching regions:", error);
        }
       }

       const fetchTransport = async () => {
        try {
            const transportResult = await MissionTransportService.transportationMode();
            if(transportResult.status){
                setTransport(transportResult.data);
            }
        } catch (error) {
            console.error("Error fetching transport:", error);
        }
       };

         if (open && agenda_id) {
            setFormvalues({
                ...initFormValues,
                mission_planning_agenda_id: agenda_id,
                mission_timesheet_id: mission_timesheet_id,
                missionnaries: (missionnaries || []).map((user) => user.user_id),
            });
            setDistrictsDepart([]);
            setDistrictsArrivee([]);
            setCommunesDepart([]);
            setCommunesArrivee([]);
            fetchRegions();
            fetchTransport();
        }
    }, [open, agenda_id, mission_timesheet_id, missionnaries, initFormValues]);

     const handleChangeRegion = async (e, value, type = "depart") => {
        const name = type === "depart" ? "region_depart" : "region_arrivee";
        const setDistricts = type === "depart" ? setDistrictsDepart : setDistrictsArrivee;
        const district = type === "depart" ? "district_depart" : "district_arrivee";
        setFormvalues({ ...formvalues, [name]: value });
          try {
            setLoading((prev) => ({ ...prev, [district]: true }));
            const districtsResult = await LocalisationMisService.getDistrictByRegion(value.id_region);
            if(districtsResult.status){
                setDistricts(districtsResult.data);
                setLoading((prev) => ({ ...prev, [district]: false }) );
            }
        } catch (error) {
            console.error("Error fetching districts:", error);
            setDistricts([]);
        }
        }
    const handleChangeDistrict = async (e, value, type = "depart") => {
        const name = type === "depart" ? "district_depart" : "district_arrivee";
        const commune = type === "depart" ? "commune_depart" : "commune_arrivee";
        const setCommunes = type === "depart" ? setCommunesDepart : setCommunesArrivee;
        setFormvalues({ ...formvalues, [name]: value });
            try {
                setLoading((prev) => ({ ...prev, [commune]: true }));
                const communesResult = await LocalisationMisService.getCommunesByDistrict(value.id_district);
                if(communesResult.status){
                    setCommunes(communesResult.data);
                    setLoading((prev) => ({ ...prev, [commune]: false }) );
                }
            } catch (error) {
                console.error("Error fetching communes:", error);
                setCommunes([]);
            }
    }
    const handleChangeCommune = (e, value, type = "depart") => {
        const name = type === "depart" ? "commune_depart" : "commune_arrivee";
        setFormvalues({ ...formvalues, [name]: value });
    }

    const verifyForm = () => {
        if(!formvalues.type || !formvalues.transport_id || !formvalues.date_begin || !formvalues.date_end || !formvalues.heure_begin || !formvalues.heure_end || !formvalues.region_depart || !formvalues.region_arrivee){
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {

        if(!verifyForm()){
            setMessage({ open: true, color: 'red', messageInfo: "Veuillez remplir tous les champs obligatoires" });
            return;
        }
        
       const dataTosend = {
        ...formvalues,
        region_depart: formvalues.region_depart ? formvalues.region_depart.nom_region : '',
        district_depart: formvalues.district_depart ? formvalues.district_depart.nom_district : '',
        commune_depart: formvalues.commune_depart ? formvalues.commune_depart.nom_commune : '',
        region_arrivee: formvalues.region_arrivee ? formvalues.region_arrivee.nom_region : '',
        district_arrivee: formvalues.district_arrivee ? formvalues.district_arrivee.nom_district : '',
        commune_arrivee: formvalues.commune_arrivee ? formvalues.commune_arrivee.nom_commune : '',
        transport_type: transport.find(item => String(item.transport_id) === String(formvalues.transport_id))?.designation || '',
       }

         try {
          setLoading((prev) => ({ ...prev, submit: true }));
          if (mission_timesheet_id === null || mission_timesheet_id === undefined || String(mission_timesheet_id) === '0') {
            if (typeof onAddDestination !== 'function') {
              setMessage({
                open: true,
                color: 'red',
                messageInfo: "Impossible d'ajouter la destination : le gestionnaire de création du brouillon est indisponible.",
              });
              return;
            }
            const created = await onAddDestination(dataTosend);
            if (created) {
              setFormvalues(initFormValues);
              onClose();
            }
            return;
          }

          const response = await TimeSheetMissionService.addOrUpdateDestination(dataTosend);
            if (!response?.status) {
                setMessage({
                    open: true,
                    color: 'red',
                    messageInfo: response?.message || "Erreur lors de l'ajout de la destination",
                });
                return;
            }

            setMessage({ open: true, color: 'green', messageInfo: "Destination ajoutée avec succès" });
            setFormvalues(initFormValues);
            onClose();
            await fetchDestinations(agenda_id);
        } catch (error) {
            setMessage({
                open: true,
                color: 'red',
                messageInfo: error?.message || "Erreur lors de l'ajout de la destination",
            });
            console.error("Error creating mission:", error);
        } finally {
            setLoading((prev) => ({ ...prev, submit: false }));
        }
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
            PaperProps={{ className: classes.dialogPaperCompact }}
        >
            <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>Ajouter une nouvelle destination</DialogTitle>
            <DialogContent dividers className={classes.dialogContent}>
               <DialogContentText component="div" className={`${classes.dialogText} ${classes.formArea}`}>
                <Grid container spacing={2}>

                <Grid container item xs={12} md={12} xl={12} spacing={2}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label className={classes.labelPosition}>Type {bullRed}</label>
                        <Autocomplete
                            fullWidth
                            disablePortal
                            id="combo-box-demo"
                            size='small'
                            onChange={(e, value) => setFormvalues({ ...formvalues, type: value ? value.id : '' })}
                            options={[{ label: 'Delai de route', id: "DR" }, { label: 'Mission', id: "DM" }]}
                            renderInput={(params) => <TextField {...params} label="Type" variant="outlined" />}
                        />
                    </FormControl>
                    
                </Grid>  
                <Grid item xs={12} sm={6} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label className={classes.labelPosition}>Moyen de transport {bullRed}</label>
                        <Autocomplete
                            fullWidth
                            disablePortal
                            id="combo-box-demo"
                            size='small'
                            onChange={(e, value) => setFormvalues({ ...formvalues, transport_id: value ? value.transport_id : '' })}
                            options={transport || []}
                            getOptionLabel={(option) => option.designation || ""}
                            renderInput={(params) => <TextField {...params} label="Transport" variant="outlined" />}
                        />
                    </FormControl>
                    
                </Grid>
                
                 <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                        <label className={classes.labelPosition}>Participants {bullRed}</label>
                       <Autocomplete
                            fullWidth
                            multiple
                            disablePortal
                            size="small"
                            options={missionnaries || []}
                            getOptionLabel={(option) => option.name || ""}
                            value={
                                missionnaries.filter((m) =>
                                formvalues.users?.includes(m.user_id)
                                ) || []
                            }
                            onChange={(e, value) =>
                                setFormvalues({
                                ...formvalues,
                                users: value.map((user) => user.user_id),
                                })
                            }
                            renderInput={(params) => (
                                <TextField {...params} label="Participants" variant="outlined" />
                            )}
                            />

                    </FormControl>
                    
                </Grid>
                
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label className={classes.labelPosition}>Date de départ {bullRed}</label>
                        <TextField variant="outlined" fullWidth size='small' type='date'
                        onChange={(e) => setFormvalues({ ...formvalues, date_begin : e.target.value })}
                        />
                    </FormControl>
                    
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label className={classes.labelPosition}>Date d'arrivé {bullRed}</label>
                        <TextField variant="outlined" fullWidth  size='small' type='date'
                        onChange={(e) => setFormvalues({ ...formvalues, date_end : e.target.value })}
                        />
                    </FormControl>
                    
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label className={classes.labelPosition}>Heure de départ {bullRed}</label>
                          <TextField
                                      fullWidth
                                      type="time"
                                      variant="outlined"      
                                      InputLabelProps={{
                                          shrink: true,
                                      }}
                                      onChange={(e) => setFormvalues({ ...formvalues, heure_begin : e.target.value })}
                                      size='small'
                                      inputProps={{
                                          'aria-label': 'Heure de départ'
                                      }}
                                  />
                    </FormControl>
                    
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label className={classes.labelPosition}>Heure d'arrivé {bullRed}</label>
                          <TextField
                                      fullWidth
                                      type="time"
                                      variant="outlined"
                                      InputLabelProps={{
                                          shrink: true,
                                      }}
                                      onChange={(e) => setFormvalues({ ...formvalues, heure_end : e.target.value })}
                                      size='small'
                                      inputProps={{
                                          'aria-label': 'Heure d\'arrivée'
                                      }}
                                  />
                    </FormControl>
                    
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label className={classes.labelPosition}>Lieu de départ {bullRed}</label>
                        {
                            loading.region_depart && <LinearProgress />
                        }
                           <Autocomplete
                            fullWidth
                            disablePortal
                            size="small"
                            options={regions || []}
                            sx={{ mb: 1 }}
                            disabled={loading.region_depart}
                            onChange={(e, value) => handleChangeRegion(e, value, "depart")}
                            getOptionLabel={(option) => option.nom_region || ""}
                            isOptionEqualToValue={(option, value) => option.id_region === value.id_region} 
                            renderInput={(params) => (
                                <TextField {...params} label={`Région`} variant="outlined" />
                            )}
                            />
                            {
                                loading.district_depart && <LinearProgress />
                            }
                         <Autocomplete
                            fullWidth
                            disablePortal
                            size='small'
                            disabled={loading.district_depart}
                            options={districtsDepart || []}
                            onChange={(e, value) => handleChangeDistrict(e, value, "depart")}
                            sx={{ mb: 1 }}
                            getOptionLabel={(option) => option.nom_district || ""}
                            renderInput={(params) => <TextField {...params} label={`District`} variant="outlined" />}
                        />
                            {
                                loading.commune_depart && <LinearProgress />
                            }
                         <Autocomplete
                            fullWidth
                            disablePortal
                            size='small'
                            options={communesDepart || []}
                            disabled={loading.commune_depart}
                            sx={{ mb: 1 }}
                            getOptionLabel={(option) => option.nom_commune || ""}
                            onChange={(e, value) => handleChangeCommune(e, value, "depart")}
                            renderInput={(params) => <TextField {...params} label="Commune" variant="outlined" />}
                        />

                    </FormControl>
                    
                </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label className={classes.labelPosition}>Lieu d'arrivé {bullRed}</label>
                        {
                            loading.region_arrivee && <LinearProgress />
                        }
                            <Autocomplete
                            fullWidth
                            disablePortal
                            disabled={loading.region_arrivee}
                            size="small"
                            options={regions || []}
                            onChange={(e, value) => handleChangeRegion(e, value, "arrivee")}
                            sx={{ mb: 1 }}
                            getOptionLabel={(option) => option.nom_region || ""}
                            isOptionEqualToValue={(option, value) => option.id_region === value.id_region} 
                            renderInput={(params) => (
                                <TextField {...params} label={`Région`} variant="outlined" />
                            )}
                            />
                            {
                                loading.district_arrivee && <LinearProgress />
                            }
                         <Autocomplete
                            fullWidth
                            disablePortal
                            disabled={loading.district_arrivee}
                            size='small'
                            options={districtsArrivee || []}
                            getOptionLabel={(option) => option.nom_district || ""}
                            onChange={(e, value) => handleChangeDistrict(e, value, "arrivee")}
                            sx={{ mb: 1 }}
                            renderInput={(params) => <TextField {...params} label={`District`} variant="outlined" />}
                        />
                            {
                                loading.commune_arrivee && <LinearProgress />
                            }
                         <Autocomplete
                            fullWidth
                            disablePortal
                            size='small'
                            disabled={loading.commune_arrivee}
                            options={communesArrivee || []}
                            getOptionLabel={(option) => option.nom_commune || ""}
                            onChange={(e, value) => handleChangeCommune(e, value, "arrivee")}
                            sx={{ mb: 1 }}
                            renderInput={(params) => <TextField {...params} label="Commune" variant="outlined" />}
                        />
                        

                    </FormControl>
                    
                </Grid>
                 
                 <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label className={classes.labelPosition}>Départ</label>
                        <TextField label="Départ" variant="outlined" fullWidth size='small' onChange={(e) => setFormvalues({ ...formvalues, lieu_depart: e.target.value })} />
                    </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth>
                        <label className={classes.labelPosition}>Vers</label>
                        <TextField label="Vers" variant="outlined" fullWidth size='small' onChange={(e) => setFormvalues({ ...formvalues, lieu_arrivee: e.target.value })} />
                    </FormControl>
                    </Grid>
                     {/* <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth>
                        <label className={classes.labelPosition}>Observation</label>
                        <TextField variant="outlined" fullWidth size='small' multiline rows={2} onChange={(e) => setFormvalues({ ...formvalues, observation: e.target.value })} />
                    </FormControl>
                </Grid> */}
                </Grid>
                {/* <Grid container item sx={6} md={5} xl={5}>
                    <MadagascarMap geoData={geodata} setGeodata={setGeodata} /> 
                </Grid> */}
                </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
             <span style={{color: "red"}} > {bullRed} indique un champ obligatoire</span>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button onClick={() => {onClose()}} color="error" variant='outlined' className={classes.actionButton}>
                        Annuler
                    </Button>
                    <Button loading={loading.submit} disabled={loading.submit}
                        loadingPosition="end" startIcon={<SaveIcon />} onClick={handleSubmit} color="info" variant='contained' autoFocus className={classes.actionButton}>
                        Enregistrer
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}

export default DestinationAddDialog;

